(function () {
    'use strict';

    /*@ngInject*/
    const RefreshLoginTokenRepository = function (baseRepository) {

        angular.extend(this, baseRepository);

        this.refreshLoginToken = (loginToken) => {
            var url = '/rest/v2/Session/refreshLoginToken',
                config = {
                    headers: {
                        'Authorization': 'UMS-TOKEN ' + loginToken
                    }
                };

            if (loginToken) {
                return this.post(url, {}, config);
            } else {
                return this.post(url);
            }
        };
    };

    angular.module('gw-um-auth')
        .service('refreshLoginTokenRepository', RefreshLoginTokenRepository);
})();
